import { Tooltip, Typography, styled, useTheme } from "@mui/material";
import { ZOOM_MAX_RATIO, ZOOM_WARN_RATIO } from "../Cropper/react-cropper/const";
import { useEffect, useRef, useState } from "react";
import { useCropperStore } from "../../store/cropper/cropper-store";
import { useCropperAction } from "../../store/cropper/cropper-actions";
import { isNumerical, isNumfast } from "../../lib/utils";
import CustomContentEditable from "../CustomContentEditable";
import PercentIcon from '@mui/icons-material/Percent';

const getZoomColor = (zoom, theme) => {
  if (zoom >= ZOOM_MAX_RATIO) {
    return theme.palette.error.main;
  } else if (zoom >= ZOOM_WARN_RATIO) {
    return theme.palette.warning.main;
  } else {
    return theme.palette.info.main;
  }
};

const zFix = value => Number( (value * 100).toFixed() ) / 100;

function ZoomIndicator({ zoom }) {
  const cropper = useCropperStore(s => s.getCropper());
  const [_zoom, _setZoom] = useState( zFix( zoom ) );
  const {dispatch: dispatchCropperAction} = useCropperAction();
  
  const getTooltipTitle = (zoom, theme) => {
    if (zoom >= ZOOM_MAX_RATIO) {
      return <span>Zoom eccessivo. La qualità di stampa potrebbe non soddisfare le tue esigenze.</span>;
    } else if (zoom >= ZOOM_WARN_RATIO) {
      return <span>Zoom elevato</span>;
    } else {
      return null;
    }
  };

  const handleChange = (event) => {
    if ( isNumerical( event.target.value ) ) {
      _setZoom( Number( event.target.value ) / 100 );
    }
  }
  
  /** ----------- Handle zoom submit ----------- */
  const handleKeyDown = event => {
    if (event.key === "Enter") { 
      event.preventDefault();
      const zoomValue = Number( event.target.textContent.trim() );
      const numValue = Math.min( zoomValue, ZOOM_MAX_RATIO * 100 );
      const value = numValue / 100;
      _setZoom(value);
      dispatchCropperAction({ _zoomRaw: { value, pivot: cropper._getContainerCenterPivot() } });
    }
  }

  const handleBlur = event => {}

  /** ----------- Update zoom on preset changed ----------- */
  useEffect(() => {
    if ( zFix(zoom) !== zFix(_zoom) ) {
      _setZoom(zFix(zoom));
    }
  }, [zoom]);

  const tooltipProps = {
    title: getTooltipTitle(zoom, useTheme()),
    color: getZoomColor(zoom, useTheme()),
  }

  return (
    <Tooltip 
      placement="top"
      slotProps={{ tooltip: { style: { backgroundColor: tooltipProps.color }}}} 
      title={tooltipProps.title}
    >
      <span>
        <CustomContentEditable 
          isNumerical
          className="cp-perimeter-ipt"
          value={ (_zoom * 100).toFixed() }
          endIcon={<PercentIcon />}
          slotProps={{
            container: {
              sx: {
                borderColor: getZoomColor(zoom, useTheme()),
              }
            },
            contentEditable: {
              onChange: handleChange,
              onKeyDown: handleKeyDown,
              style: {
                color: getZoomColor(zoom, useTheme()),
                fontSize: '1em',
                lineHeight: 1,
                fontFamily: 'monospace',
                border: 0,
                padding: 0,
                display: 'flex'
              },
              onBlur: handleBlur,
            }
          }}
        />
      </span>
    </Tooltip>
  );
};

export default ZoomIndicator;